<div class="open-slow" [ngClass]="{ 'open-slow-to-height': seenBy.length }">
  @for (icon of seenBy; track icon; let i = $index) {
    <span>
      @if (icon.participant) {
        <div class="seen-bubbles">
          @if (
            [icon.participant.firstName, icon.participant.lastName]
              | concatNotNull;
            as participantName
          ) {
            @if (i === maxBubbles) {
              <div class="extra" [matTooltip]="'Click for more info'">
                <div>
                  <span>+{{ seenBy.length - maxBubbles }}</span>
                </div>
              </div>
            }
            @if (i < maxBubbles) {
              <div
                class="seen-bubble-padding seen-bubble-style"
                [matTooltip]="'Seen by ' + participantName"
              >
                <div class="avatar">
                  <app-avatar
                    class="celo-cursor-pointer"
                    [name]="participantName"
                    [userId]="icon.participant.userId"
                    [width]="16"
                    [height]="16"
                    [hasImage]="!!icon.participant.profilePicture"
                  >
                  </app-avatar>
                </div>
              </div>
            }
          }
        </div>
      }
    </span>
  }
</div>
@if (!seenBy.length) {
  <div class="status-bar">
    @if (userAccount.userId === message.sentBy) {
      <div>
        @if (getDelivered().length) {
          <div class="with-icon" data-delivery-state="delivered">
            <mat-icon matTooltip="Delivered">check_circle</mat-icon>
          </div>
        }
        @if (!getDelivered().length) {
          <div>
            @if (!getSending().length || getSent().length) {
              <div class="with-icon" data-delivery-state="sent">
                <mat-icon matTooltip="Sent">check_circle_outline</mat-icon>
              </div>
            }
            @if (getSending().length && getSent().length === 0) {
              <div class="with-icon">
                @if (message.NOT_SENT) {
                  <div
                    data-delivery-state="failed"
                    (click)="
                      $event.preventDefault();
                      $event.stopPropagation();
                      message.NOT_SENT_RETRY_FUNC()
                    "
                    class="send-fail"
                  >
                    <span>Failed, Click to retry</span>
                    <mat-icon class="icon_v" matTooltip="Retry"
                      >settings_backup_restore</mat-icon
                    >
                  </div>
                }
                @if (!message.NOT_SENT) {
                  <span data-delivery-state="sending">
                    <mat-icon matTooltip="Sending">panorama_fish_eye</mat-icon>
                  </span>
                }
              </div>
            }
            <!-- <div class="with-icon" *ngIf="getSent().length">
              <mat-icon matTooltip="Sent">check_circle_outline</mat-icon>
            </div>
            <div *ngIf="!getSent().length">
              1
              <div *ngIf="getSending().length" class="with-icon">
                <div
                  *ngIf="message.NOT_SENT"
                  (click)="$event.preventDefault();$event.stopPropagation();message.NOT_SENT_RETRY_FUNC();"
                  class="send-fail">
                  <span>Failed, Click to retry</span>
                  <mat-icon class="icon_v" matTooltip="Retry">settings_backup_restore</mat-icon>
                </div>
                <span *ngIf="!message.NOT_SENT">
                  <mat-icon matTooltip="Sending">panorama_fish_eye</mat-icon>
                </span>
              </div>
            </div> -->
          </div>
        }
      </div>
    }
  </div>
}
